import {
    Stack,
    Box,
    Text,
    Image,
    Flex,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    useDisclosure,
} from '@chakra-ui/react'
import { useState } from 'react'
import { colors } from 'src/common/colors'
import { openUrl } from 'src/common/util'
import { ClubDetailData } from "src/hooks/SearchInfo/useGetClubDetails"

type Props = {
    club: ClubDetailData
}

export default function ClubInfo(props: Props) {
    const { club } = props
    const { isOpen, onOpen, onClose } = useDisclosure()
    const [modalTitle, setModalTitle] = useState('')
    const [modalImg, setModalImg] = useState('')

    const handleModal = (img: string, title: string) => {
        setModalImg(img)
        setModalTitle(title)
        onOpen()
    }

    return (
        <>
            <Flex alignItems='center' marginBottom='55px'>
                <Box
                    width='161px'
                    height='161px'
                    border={`3px solid ${colors.button.blue}`}
                    borderRadius='50%'
                    overflow='hidden'
                    marginRight='42px'
                    display='flex'
                    alignItems='center'
                    justifyContent='center'
                >
                    <Image
                        width='100%'
                        height='100%'
                        objectFit='cover'
                        src={club.academyLogoUrl}
                        alt={club.academyName}
                    />
                </Box>
                <Flex direction='column' gap='10px'>
                    <Text fontFamily='NanumSquareNeoEBold' fontSize='24px' color={colors.darkBlue} lineHeight='162%'>{club.academyName}</Text>
                    <Stack className='club-info'>
                        <Text>주소 : {club.academyAddress}</Text>
                        <Text>회원 수 : {club.memberCount}명</Text>
                        <Text>클럽 연락처 : {club.contact}</Text>
                        <Text>SNS :&nbsp;
                            <span
                                style={{textDecoration:'underline', textUnderlineOffset:'6px', cursor:'pointer'}}
                                onClick={()=>{openUrl(club.snsUrl)}} 
                            >
                                확인하기
                            </span>
                        </Text>
                    </Stack>
                </Flex>
            </Flex>
            <Stack>
                <Box borderBottom='1px solid rgba(19, 28, 77, 0.28)' marginBottom='45px'>
                    <Text
                        color={colors.darkBlue}
                        fontSize='18px'
                        padding='0 0 16px 14px'
                        borderBottom={`3px solid ${colors.button.blue}`}
                        width='101px'
                        fontFamily='KFAGothic'
                    >
                        클럽 정보
                    </Text>
                </Box>
                <Flex flexDirection='row'>
                    <Flex flex='1' direction='column' color={colors.darkBlue} marginBottom='59px'>
                        <Text fontSize='22px' color={colors.darkBlue} fontFamily='KFAGothicBold' marginBottom='24px'>사업자 정보</Text>
                        <Text fontSize='16px' marginBottom='20px'>대표자 이름: {club.academyCeoName}</Text>
                        <Text
                            fontSize='16px'
                            marginBottom='20px'
                            display='flex'
                            flexDirection='row'
                        >
                            대표자 신분증:&nbsp;
                            {club.academyCeoIdCardUrl.length > 0 
                            ? <Text 
                                textDecoration='underline' 
                                textUnderlineOffset='6px' 
                                cursor='pointer'
                                onClick={()=>{handleModal(club.academyCeoIdCardUrl, '대표자 신분증')}} 
                            >
                                확인하기
                            </Text>
                            : <Text color={colors.lightGrey}>등록 전</Text>}
                        </Text>
                        <Text
                            fontSize='16px'
                            marginBottom='20px'
                            display='flex'
                            flexDirection='row'
                        >
                            대표자 통장사본:&nbsp;
                            {club.academyCeoBankCopyUrl.length > 0 
                            ? <Text 
                                textDecoration='underline' 
                                textUnderlineOffset='6px' 
                                cursor='pointer'
                                onClick={()=>{handleModal(club.academyCeoBankCopyUrl, '대표자 통장사본')}} 
                            >
                                확인하기
                            </Text>
                            : <Text color={colors.lightGrey}>등록 전</Text>}
                        </Text>
                        <Text fontSize='16px' marginBottom='20px'>사업자 번호: {club.academyBusinessNumber}</Text>
                        <Text
                            fontSize='16px'
                            marginBottom='20px'
                            display='flex'
                            flexDirection='row'
                        >
                            사업자 등록증:&nbsp;
                            {club.academyBusinessCertificateUrl.length > 0 
                            ? <Text 
                                textDecoration='underline' 
                                textUnderlineOffset='6px' 
                                cursor='pointer'
                                onClick={()=>{handleModal(club.academyBusinessCertificateUrl, '사업자 등록증')}} 
                            >
                                    확인하기
                            </Text>
                            : <Text color={colors.lightGrey}>등록 전</Text>}
                        </Text>
                    </Flex>
                    <Flex flex='1' direction='column' color={colors.darkBlue} marginBottom='59px'>
                        <Text fontSize='22px' color={colors.darkBlue} fontFamily='KFAGothicBold' marginBottom='24px'>구장 정보</Text>
                        <Text fontSize='16px' marginBottom='20px'>보유 구장 개수: {club.stadiumCount}</Text>
                        <Text fontSize='16px' marginBottom='20px'>보유 구장 형태: {club.stadiumType}</Text>
                        <Text fontSize='16px' marginBottom='20px'>보유 구장 가로 크기(가장 큰 구장 기준): {club.largestStadiumWidth}m</Text>
                        <Text fontSize='16px' marginBottom='20px'>보유 구장 세로 크기(가장 큰 구장 기준): {club.largestStadiumLength}m</Text>
                    </Flex>
                </Flex>
                
                <Stack>
                    <Text fontSize='22px' color={colors.darkBlue} fontFamily='KFAGothicBold' marginBottom='25px'>담당 지도자 정보</Text>
                    <Flex flexWrap='wrap' justifyContent='space-between'>
                        {club.academyCoachList?.length ?
                            club.academyCoachList.map((coach, i) => (
                                <Flex
                                    key={i}
                                    width='49%'
                                    minHeight='166px'
                                    height='100%'
                                    marginBottom='21px'
                                    padding='20px 0 20px 24px'
                                    border='1px solid rgba(19, 28, 77, 0.15)'
                                    borderRadius='8px'
                                    direction='column'
                                    justifyContent='center'
                                    gap='14px'
                                >
                                    <Text fontSize='16px' color={colors.darkBlue}>담당 지도자 이름: {coach ? coach.coachName : '지도자 이름이 등록 되지 않았습니다.'}</Text>
                                    <Text fontSize='16px' color={colors.darkBlue}>담당 지도자 연락처: {coach ? coach.coachPhoneNumber : '지도자 연락처가 등록 되지 않았습니다.'}</Text>
                                    <Text fontSize='16px' color={colors.darkBlue} display={'flex'}>
                                        담당 지도자 자격증:&nbsp;
                                        {coach?.coachLicenseImageUrl.length > 0 
                                        ? <Text 
                                            textDecoration='underline' 
                                            textUnderlineOffset='6px' 
                                            cursor='pointer'
                                            onClick={()=>{handleModal(coach.coachLicenseImageUrl, '담당 지도자 자격증')}} 
                                        >
                                             확인하기
                                        </Text>
                                        : <Text color={colors.lightGrey}>등록 전</Text>}
                                    </Text>
                                </Flex>
                            ))
                            :
                            <Text color={colors.darkBlue}>등록된 지도자가 없습니다.</Text>
                        }
                    </Flex>
                </Stack>
            </Stack>

            <Modal isOpen={isOpen} onClose={onClose} size={'xl'}>
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>{modalTitle}</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        <Flex width={'100%'} height={'65vh'}>
                            <Image src={modalImg} alt='' objectFit='contain' />
                        </Flex>
                    </ModalBody>
                    <ModalFooter/>
                </ModalContent>
            </Modal>
        </>
    )
}